export const isTestCafeTest = () => window?.location?.port === '6000'
